import { safeGetLocalStorageItem } from '~/utils/localStorage';

const DEFAULT_REPORTS_PER_PAGE = 25;

export const getPersistedReportsPerPage = () =>
  parseInt(safeGetLocalStorageItem('cryptobot_reports_per_page'), 10) || DEFAULT_REPORTS_PER_PAGE;

export const setPersistedReportsPerPage = (items: number) =>
  localStorage.setItem('cryptobot_reports_per_page', items.toString());
